import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { environment } from '../../../environment';
import { useAuth } from '../../../hooks/auth/use-auth';
import { IntegrationDefaultEnum } from '../../../types';
import { isProd } from '../../../utils/helpers';
import { isWisniowski } from '../../../utils/helpers/wisniowski';
import { getSelectedTheme, removeBodyClass } from '../../../utils/theme';

export const useLogin = () => {
  const { keycloak } = useAuth();
  const { i18n } = useTranslation('login');
  const [wisniowski, setWisniowski] = useState<boolean>(false);
  const theme = getSelectedTheme();
  const redirectUrl = `${location.protocol}${environment.PUBLIC_URL}?theme=${theme}`;

  useEffect(() => {
    if (isWisniowski) {
      removeBodyClass('dark');
      setWisniowski(true);
    }
  }, []);

  const getSocialIdpHint = (type: 'facebook' | 'google' | 'apple') => {
    if (!isProd) {
      switch (environment.INTEGRATION_DEFAULT) {
        case IntegrationDefaultEnum.Exalus:
          return `${type}-exalus`;
        case IntegrationDefaultEnum.Wisniowski:
          return `${type}-wisniowski`;
        default:
          return type;
      }
    }

    return type;
  };

  const handleSocialLogin = (type: 'facebook' | 'google' | 'apple') => {
    const idpHint = getSocialIdpHint(type);

    keycloak.login({
      locale: i18n.language,
      redirectUri: redirectUrl,
      scope: 'openid profile email',
      idpHint,
    });
  };

  const handleLogin = () => {
    keycloak.login({
      locale: i18n.language,
      redirectUri: redirectUrl,
      scope: 'openid profile email',
    });
  };

  const handleRegister = () => {
    keycloak.register({
      locale: i18n.language,
      redirectUri: redirectUrl,
    });
  };

  return {
    wisniowski,
    handleLogin,
    handleSocialLogin,
    handleRegister,
  };
};
